export default __webpack_public_path__ + "static/media/Pingry.6ddf8116.png";